import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { KB_URL_MANAGE_SEATS } from '../../constants/externalUrls';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonText = styled.span.withConfig({
  displayName: "LearnMoreButton__ButtonText",
  componentId: "sc-1dwh3bc-0"
})(["text-decoration:underline;"]);
const LearnMoreButton = () => /*#__PURE__*/_jsx(UIButton, {
  "data-test-id": "learn-more",
  use: "secondary",
  href: KB_URL_MANAGE_SEATS,
  children: /*#__PURE__*/_jsx(ButtonText, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "calling-orchestration-shared-library.unlock-calling.learn-more-button-text"
    })
  })
});
export default LearnMoreButton;